import React, { useState, useEffect } from 'react';
import {Button} from 'react-native';

const ItemList = () => {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchItems = async () => {
            try {
                const response = await fetch('https://us-central1-pika-jessica.cloudfunctions.net/api/items');
                if (!response.ok) {
                    throw new Error(`Error: ${response.statusText}`);
                }
                const data = await response.json();

                const sortedItems = data.sort((a, b) => new Date(b.createdDt) - new Date(a.createdDt));

                console.log("sortedItems====>",sortedItems);
                setItems(sortedItems);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchItems();
    }, []);

    const resetCredit = async (email) => {
        try {
            const response = await fetch('https://us-central1-pika-jessica.cloudfunctions.net/api/items/reset-credit', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email }),
            });

            if (!response.ok) {
                throw new Error(`Error: ${response.statusText}`);
            }

            const data = await response.json();
            console.log('Credit reset successful:', data);
            alert('Credit reset successful')
            return data;
        } catch (err) {
            console.error('Failed to reset credit:', err.message);
            throw err;
        }
    };

    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error: {error}</div>;

    return (
        <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
            <h1>Items Table</h1>
            <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '20px' }}>
                <thead>
                <tr>
                    <th style={headerStyle}>reset</th>
                    <th style={headerStyle}>ID</th>
                    <th style={headerStyle}>Email</th>
                    <th style={headerStyle}>Credit</th>
                    <th style={headerStyle}>Created Date</th>
                    <th style={headerStyle}>isMember</th>
                    <th style={{
                        border: '1px solid #ddd',
                        padding: '8px',
                        backgroundColor: '#f4f4f4',
                        textAlign: 'left',
                        fontWeight: 'bold',
                        width: 90,
                    }}>transactionReceipt
                    </th>
                </tr>
                </thead>
                <tbody>
                {items.map((item) => (
                    <tr key={item._id}>
                        <td>
                            <button  onClick={async ()=>{
                                await resetCredit(item.email)
                            }} >
                                reset
                            </button>
                        </td>
                        <td style={cellStyle}>{item._id}</td>
                        <td style={cellStyle}>{item.email}</td>
                        <td style={cellStyle}>{item.credit}</td>

                        <td style={cellStyle}>{item.createdDt}</td>
                        <td style={cellStyle}>{item.isMember?.toString()}</td>
                        <td style={{  width:90,}}>{item.transactionReceipt}</td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
};

const headerStyle = {
    border: '1px solid #ddd',
    padding: '8px',
    backgroundColor: '#f4f4f4',
    textAlign: 'left',
    fontWeight: 'bold',
};

const cellStyle = {
    border: '1px solid #ddd',
    padding: '8px',
    textAlign: 'left',
};

export default ItemList;
